import { createAsyncThunk } from '@reduxjs/toolkit';
import { FlowOfFunds } from '../../../../models/FlowOfFunds/flow-of-funds.model';

// GET /api/FlowOfFunds/{id} serves a live view over the winning buyer's LOI —
// not a frozen settlement document. Every engagement without a winning buyer
// with a selected LOI 404s here, so this fails quietly (no error toast) and
// the sub-tabs fall back to their empty state.
export const GetFlowOfFunds = createAsyncThunk(
    'flowOfFunds/getFlowOfFunds',
    async (engagementId: number, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        const response = await axios.get(
            `/api/FlowOfFunds/${engagementId}`
        );

        if (response.status !== 200) {
            throw new Error('Failed to fetch the flow of funds');
        }

        return response.data as FlowOfFunds;
    }
);
